<template>
  <div class="row">
    <div class="col-12 layoutPadding-30" style="/*padding:0*/">
      <div
        class="row mb-3"
        style="justify-content: space-between; margin: auto"
      >
        <div class="team-title mt-2 d-flex">
          <i class="material-icons-outlined user-font mr-2 material-icon-font"
            >monetization_on</i
          >
          <div style="margin-top: auto; margin-bottom: auto">Fund</div>
        </div>
      </div>
      
      <b-tabs v-model="tabIndex" class="thesisTabs">
        <b-tab
          title="Overview"
          :disabled="showLpAllocationsTab"
          :active="showOverview"
        >
          <lpAllocation ref="lpRef" :context="'gp'" v-if="tabIndex===0"></lpAllocation>
        </b-tab>
        <b-tab title="Calls" :disabled="showCallsTab">
          <CapitalCallTab ref="capitalCallRef" :context="'gp'"></CapitalCallTab>
        </b-tab>
        <b-tab title="Distributions" :disabled="showDistributionsTab">
          <DistributionsTab
            ref="distributionRef"
            :context="'gp'"
          ></DistributionsTab>
        </b-tab>
         <b-tab title="Recycling">
          <recyclingTab v-if="tabIndex === 3" :context="'gp'"></recyclingTab>
        </b-tab>
        <b-tab title="LP Documents" :disabled="showDocumentsTab">
          <lpDocuments ref="lpDocumentsRef"></lpDocuments>
        </b-tab>
        <b-tab
          title="Formation Documents"
          :disabled="showFormationDocumentsTab"
        >
          <formationDocuments ref="formationDocumentsRef"></formationDocuments>
        </b-tab>
        <b-tab
          title="Archived LP Documents"
          :disabled="showFormationDocumentsTab"
        >
          <archievedDocuments ref="archievedDocumentsRef"></archievedDocuments>
        </b-tab>
        <b-tab></b-tab>
        <b-tab title="Thesis" :active="!showOverview">
          <thesisTab ref="thesisRef"></thesisTab>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import ThesisTab from "./ThesisTab";
import LPAllocations from "./LPAllocations";
import CapitalCallTab from "./CapitalCallTab";
import DistributionTab from "./DistributionsTab";
import LPDocumentsTab from "./LPDocumentsTab";
import FormationDocumentsTab from "./FormationDocumentsTab";
import RecyclingTab from "./RecyclingTab";
import ArchievedDocuments from "./ArchievedDocuments";
import { mapGetters } from "vuex";
export default {
  name: "thesis",
  components: {
    [ThesisTab.name]: ThesisTab,
    [LPAllocations.name]: LPAllocations,
    [CapitalCallTab.name]: CapitalCallTab,
    [DistributionTab.name]: DistributionTab,
    [LPDocumentsTab.name]: LPDocumentsTab,
    [FormationDocumentsTab.name]: FormationDocumentsTab,
    [RecyclingTab.name]: RecyclingTab,
    [ArchievedDocuments.name]: ArchievedDocuments,
  },
  data() {
    return {
      tabIndex: 0,
      chek: 0,
      showOverview: false,
    };
  },
  computed: {
    ...mapGetters("lpAllocations", ["thesisData", "lpDetailsData"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    isDisabled() {
      return this.thesisData && this.thesisData.length > 0 ? false : true;
    },
    isDocumentsDisbaled() {
      return this.thesisData &&
        this.thesisData.length > 0 &&
        this.lpDetailsData &&
        this.lpDetailsData.length > 0
        ? false
        : true;
    },
    showLpAllocationsTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW LP ALLOCATIONS") {
          return item;
        }
      });
      return index >= 0 && this.thesisData && this.thesisData.length > 0
        ? false
        : true;
    },
    showCallsTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW CALLS") {
          return item;
        }
      });
      return index >= 0 && this.thesisData && this.thesisData.length > 0
        ? false
        : true;
    },
    showDistributionsTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW DISTRIBUTIONS") {
          return item;
        }
      });
      return index >= 0 && this.thesisData && this.thesisData.length > 0
        ? false
        : true;
    },
    showDocumentsTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW LPDOCUMENTS") {
          return item;
        }
      });
      return index >= 0 &&
        this.thesisData &&
        this.thesisData.length > 0 &&
        this.lpDetailsData &&
        this.lpDetailsData.length > 0
        ? false
        : true;
    },
    showFormationDocumentsTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW LPDOCUMENTS") {
          return item;
        }
      });
      return index >= 0 && this.thesisData && this.thesisData.length > 0
        ? false
        : true;
    },
  },
  mounted() {
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Fund`;
    this.showOverview =
      this.thesisData &&
      this.thesisData.length > 0 &&
      !this.showLpAllocationsTab
        ? true
        : false;
  },
};
</script>
<style>
.thesisTabs .nav-tabs li:nth-child(8) {
  visibility: hidden;
  flex-grow: 1;
}
</style>